/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('PublicFolderInterceptor', [
        'RoutePaths',
        function (RoutePaths) {
            return {
                response: function (response) {
                    return angular.isArray(response.resource) ? response.resource.map(_decorateNode) : _decorateNode(response.resource);
                }
            };

            function _decorateNode(node) {
                return Object.defineProperties(node, {
                    getUrl: {
                        value: function (withoutHash) {
                            var hashChar = withoutHash === true ? '' : '#';

                            return hashChar + RoutePaths.PUBLIC_FOLDER + '/' + this.uuid;
                        }
                    },
                    // The `type` property is added here so the folder icon can appear properly
                    // without a need to change accResourceTypeIcon component
                    type: {
                        get: function () {
                            return this.is_directory ? 'folder' : '';
                        }
                    },
                    canBePreviewed: {
                        get: function () {
                            return node.actions.preview != null;
                        }
                    },
                    canBeDownloaded: {
                        get: function () {
                            return node.actions.download != null;
                        }
                    }
                });
            }
        }
    ]);
